import { AdminInstructors  } from './TS_Instructors'
import { AdminClassTypes } from './TS_ClassType'
import { AdminClasses } from './TS_Classes'
import {  TruFitCalendar } from './TS_Calendar'

// import * as moment from '../node_modules/moment/moment'

/*

EXPORTING THE MODULES THAT WILL BE CONSUMED FROM THE OUTSIDE. 

*/

export {
    AdminInstructors, AdminClassTypes,
    AdminClasses, TruFitCalendar,
    // moment
}



// $(document).ready(() => {
    

//     new TruFitCalendar({
//         Endpoint: '/specdev/trufitgym/methods.aspx',
//         Panel: '#pnlCalendar',
//         ModalPanel: '#pnlModal',
//     });





//     new AdminClasses({
//         Endpoint: '/specdev/trufitgym/methods.aspx',
//         Panel: '#pnlClassesAdmin',
//         ModalPanel: '#pnlModal',
//         InsertPanel: '#pnlClassesInsert',
//         // BlockerConfig: {
//         //     CssColor: 'red',
//         //     CssOpacity: 0.9,
//         // }
//     });
    
//     new AdminInstructors({
//         Endpoint: '/specdev/trufitgym/methods.aspx',
//         Panel: '#pnlInstructorsAdmin',
//         ModalPanel: '#pnlModal',
//         InsertPanel: '#pnlInstructorsInsert',
//         // BlockerConfig: {
//         //     CssColor: 'red',
//         //     CssOpacity: 0.9,
//         // }
//     });
     
//     new AdminClassTypes({
//         Endpoint: '/specdev/trufitgym/methods.aspx',
//         Panel: '#pnlClassTypeAdmin',
//         ModalPanel: '#pnlModal',
//         InsertPanel: '#pnlClassTypeInsert',
//         // BlockerConfig: {
//         //     CssColor: 'red',
//         //     CssOpacity: 0.9,
//         // }
//     });
    

//     return;
    








//     // var b = new Blocker();
//     // b.Block();
    
//     // var mdl = new BsModal({ Panel: '#pnlModal' });
    
//     // mdl.Confirm("Hola bola", (result:boolean) => {
//     //     console.log("Dialog accept ? %s", result);
//     // }, "What a cool title my man !")
    
//     // mdl.Alert("Hola bola", () => {
//     //     console.log("Marolled");
//     // }, "What a cool title uh !")
    
// });


// WEBPACK FOOTER //
// ./js/App.ts